var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "AddPicking" },
    [
      _c(
        "div",
        { staticClass: "AddPicking__top" },
        [
          _c(
            "el-descriptions",
            { attrs: { column: 3 } },
            [
              _c("el-descriptions-item", { attrs: { label: "系统单号" } }, [
                _c("div", [_vm._v(_vm._s(_vm.pickingData.rsys))]),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "检索单号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入内容(选填)" },
                    model: {
                      value: _vm.pickingData.retrieval,
                      callback: function ($$v) {
                        _vm.$set(_vm.pickingData, "retrieval", $$v)
                      },
                      expression: "pickingData.retrieval",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "订单号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入内容(选填)" },
                    model: {
                      value: _vm.pickingData.order,
                      callback: function ($$v) {
                        _vm.$set(_vm.pickingData, "order", $$v)
                      },
                      expression: "pickingData.order",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "el-descriptions",
            { attrs: { column: 3 } },
            [
              _c(
                "el-descriptions-item",
                { attrs: { label: "出货门店" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "请选择" },
                      on: { change: _vm.checkStore },
                      model: {
                        value: _vm.storeId,
                        callback: function ($$v) {
                          _vm.storeId = $$v
                        },
                        expression: "storeId",
                      },
                    },
                    _vm._l(_vm.allStores, function (item) {
                      return _c("el-option", {
                        key: item.sid,
                        attrs: { label: item.cname, value: item.sid },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("el-descriptions-item", { attrs: { label: "门店地址" } }, [
                _c("div", { staticClass: "wHP" }, [
                  _vm._v(_vm._s(_vm.storeInfo.caddr)),
                ]),
              ]),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "div",
            { staticClass: "flex alignItemsCenter" },
            [
              _c(
                "el-descriptions",
                { attrs: { column: 3 } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "订单渠道" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { filterable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.pickingData.rchannel,
                            callback: function ($$v) {
                              _vm.$set(_vm.pickingData, "rchannel", $$v)
                            },
                            expression: "pickingData.rchannel",
                          },
                        },
                        _vm._l(_vm.channelOptions, function (item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.name, value: item.code },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "顾客地址" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入内容" },
                        model: {
                          value: _vm.pickingData.customerAddr,
                          callback: function ($$v) {
                            _vm.$set(_vm.pickingData, "customerAddr", $$v)
                          },
                          expression: "pickingData.customerAddr",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("span", { staticClass: "icon iconfont grey" }, [_vm._v("")]),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "div",
            { staticClass: "flex alignItemsCenter" },
            [
              _c(
                "el-descriptions",
                { attrs: { column: 4 } },
                [
                  _c("el-descriptions-item", { attrs: { label: "销售组织" } }, [
                    _c("div", { staticClass: "wHP" }, [
                      _vm._v(_vm._s(_vm.pickingData.shopFinanceName)),
                    ]),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "销售门店" } }, [
                    _c("div", { staticClass: "wHP" }, [
                      _vm._v(_vm._s(_vm.pickingData.shopName)),
                    ]),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "库存组织" } }, [
                    _c("div", { staticClass: "wHP" }, [
                      _vm._v(_vm._s(_vm.pickingData.storeFinanceName)),
                    ]),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "出库门店" } }, [
                    _c("div", { staticClass: "wHP" }, [
                      _vm._v(_vm._s(_vm.storeInfo.cname)),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c(
                "el-descriptions",
                { attrs: { column: 1 } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "单据备注" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入内容(选填)" },
                        model: {
                          value: _vm.pickingData.remarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.pickingData, "remarks", $$v)
                          },
                          expression: "pickingData.remarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "w200 flex",
                  staticStyle: { "justify-content": "flex-end" },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini", plain: "" },
                      on: {
                        click: function ($event) {
                          _vm.deviceDialogVisible = true
                        },
                      },
                    },
                    [_vm._v("门店智控")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "h450 AddPicking__table" },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              attrs: { data: _vm.tableData, height: "450" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  align: "center",
                  width: "50",
                  type: "index",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "SKU", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { maxlength: "5", placeholder: "SKU" },
                          on: {
                            input: function ($event) {
                              return _vm.checkSKU(scope.$index)
                            },
                          },
                          model: {
                            value: scope.row.cremark,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "cremark", $$v)
                            },
                            expression: "scope.row.cremark",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "图片", align: "center", width: "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.cmasterUrl
                          ? _c("el-image", {
                              staticClass: "w50 h50",
                              attrs: {
                                "preview-src-list": [scope.row.cmasterUrl],
                                src: scope.row.cmasterUrl,
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "货品编码",
                  align: "center",
                  width: "130",
                  prop: "csku",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "货品名称", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              disabled: !scope.row.c_name,
                              content: scope.row.c_name,
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { color: "red" },
                                attrs: {
                                  filterable: "",
                                  placeholder: "请选择",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.checkGoodsName(scope.$index)
                                  },
                                },
                                model: {
                                  value: scope.row.sid,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "sid", $$v)
                                  },
                                  expression: "scope.row.sid",
                                },
                              },
                              _vm._l(_vm.allInventorys, function (item) {
                                return _c("el-option", {
                                  key: item.sid,
                                  attrs: {
                                    label:
                                      item.sgoods +
                                      "可用数量：" +
                                      item.navailable,
                                    value: item.sid,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "单位", align: "center", width: "50" },
              }),
              _c("el-table-column", {
                attrs: { label: "单价", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.nprice
                          ? _c("div", [
                              _vm._v("￥ " + _vm._s(scope.row.nprice)),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "库位",
                  align: "center",
                  width: "70",
                  prop: "c_num",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "hHP wHP flex marginLeft10",
                            staticStyle: { "white-space": "break-spaces" },
                          },
                          [
                            _c("el-link", { attrs: { type: "primary" } }, [
                              _vm._v(_vm._s(scope.row.cwarehouse)),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "数量", align: "center", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input-number", {
                          attrs: {
                            "controls-position": "right",
                            min: 1,
                            max: 999,
                          },
                          model: {
                            value: scope.row.num,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "num", $$v)
                            },
                            expression: "scope.row.num",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  fixed: "right",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "red",
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.onDel(scope.$index)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "red",
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleShowSurplusDialog(scope.row)
                              },
                            },
                          },
                          [_vm._v("校正库存")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "flex alignItemsCenter marginTop10",
          staticStyle: { "justify-content": "space-between", flex: "1" },
        },
        [
          _c("div", [
            _vm._v(" 共计 "),
            _c("span", { staticClass: "blue" }, [
              _vm._v(
                _vm._s(
                  _vm.tableData.length > 1
                    ? _vm.tableData.length - 1
                    : _vm.tableData.length
                ) + "种"
              ),
            ]),
            _vm._v(" 货品 "),
          ]),
          _c(
            "div",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.doSubmit } },
                [_vm._v("提交")]
              ),
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("关 闭"),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm.deviceDialogVisible
        ? _c(
            "el-dialog",
            {
              staticClass: "elDialog",
              attrs: {
                "close-on-click-modal": false,
                title: "查看门店智控",
                visible: _vm.deviceDialogVisible,
                width: "400px",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.deviceDialogVisible = $event
                },
              },
            },
            [_c("deviceControl", { attrs: { "store-info": _vm.storeInfo } })],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            title: "库存校正",
            visible: _vm.surplusDialog,
            width: "400px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.surplusDialog = $event
            },
          },
        },
        [
          _vm.surplusDialog
            ? _c("surplusSheet", {
                attrs: { "picking-detail": _vm.pickingDetail },
                on: {
                  handleSubmit: _vm.handleSurplusSheetSubmit,
                  handleClose: _vm.handleSurplusSheetSubmit,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }